import React from 'react';

import { H3 } from 'components/core/Headline';
import { Paragraph } from 'components/core/Paragraph';

import './storageQuestions.scss';

export function StorageQuestions() {
	return (
		<div className="section-container storage-questions">
			<div className="section-content">
				<div className="portable-storage-content">
					<H3>
						What is portable storage?
					</H3>
					<Paragraph size="small">
						Portable storage, or mobile storage, containers emulate the stationary type of storage unit
						you'd rent at a storage facility. The only difference is that they're dropped off and picked
						up at your convenience.
					</Paragraph>
					<H3>
						How does portable storage work?
					</H3>
					<Paragraph size="small">
						A truck will drop off the storage container at your house. Once you pack it with all your stuff,
						you can keep it on your property or have the mobile storage company pick it up and take it back
						to their warehouse. Moving? They can also deliver it to your new home.
					</Paragraph>
				</div>
			</div>
		</div>
	);
}

export default StorageQuestions;
